/* src/app/core/components/modal-error/modal-error.component.scss */
/*# sourceMappingURL=/avvera/dev/modal-error.component.css.map */
